import { Component, OnDestroy, OnInit } from '@angular/core';
import { ActivatedRoute } from '@angular/router';

import { Subscription } from 'rxjs/internal/Subscription';

import { LessonStatus, Teacher } from '@df/interfaces';
import { TeacherService } from '@app/teacher/services/teacher.service';
import { AccountService } from '@app/teacher/services/account.service';

@Component({
    selector: 'app-teach-class-list',
    templateUrl: './teach-class-list.component.html',
    styleUrls: ['./teach-class-list.component.scss']
})
export class TeachClassListComponent implements OnInit, OnDestroy {
    public lesson_created = LessonStatus.LESSON_CREATED;
    public teacher: Teacher;
    public classId: number;
    private routeDataSubscription: Subscription;
    private routeParamsSubscription: Subscription;

    constructor(
        private route: ActivatedRoute,
        private accountService: AccountService,
        private teacherService: TeacherService
    ) {}

    ngOnInit() {
        this.routeDataSubscription = this.accountService.$currentTeacher.subscribe((teacher: Teacher) => {
            this.teacher = teacher;
        });
        this.routeParamsSubscription = this.route.parent.params.subscribe(params => {
            this.classId = +params['class_id'];
            this.teacherService.setClassId(this.classId);
        });
    }

    ngOnDestroy() {
        this.routeParamsSubscription.unsubscribe();
        this.routeDataSubscription.unsubscribe();
    }
}
